import BusyIndicator from "react-busy-indicator";
import React from "react";

export default (props) => {
    return <BusyIndicator {...props}  color="#2187d3" />
}